import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PermisiuniActiuniService } from '../permisiuni-actiuni.service';
import { AuthService } from 'src/app/services/auth.service';
import { Observable, finalize, of } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { PermisiuniService } from '../../permisiuni/permisiuni.service';
import { IPermisiune } from '../../permisiuni/permisiuni.interface';

@Component({
  selector: 'app-edit-permisiuni-actiuni',
  templateUrl: './edit-permisiuni-actiuni.component.html',
  styleUrls: ['./edit-permisiuni-actiuni.component.scss']
})
export class EditPermisiuniActiuniComponent implements OnInit {
  // general error
  errorTitle: string = environment.config.customNotifications.headers.error
  errorIcon: string = environment.config.customNotifications.icons.error
  errorType: string = environment.config.customNotifications.icons.error

  token!: string;
  isLoading = false;
  isPermisiuniLoading = true;
  permisiuni$!: Observable<IPermisiune[]>

  form: FormGroup = new FormGroup({
    name: new FormControl(this.data.name),
    slug: new FormControl(this.data.slug),
    id_permission: new FormControl(this.data.id_permission),
  });

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private dialogRef: MatDialogRef<EditPermisiuniActiuniComponent>,
    private permisiuniActiuniService: PermisiuniActiuniService,
    private permisiuniService: PermisiuniService,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {
    this.processToken();
  }

  ngOnInit(): void {
    this.getPermisiuniList();
  }

  getPermisiuniList() {
    this.permisiuni$ = this.permisiuniService.getPermisiuniList();
    this.permisiuni$
    .pipe(
      finalize(() => (this.isPermisiuniLoading = false))
    )
    .subscribe({
      next: (permisiuni) => {
        this.permisiuni$ = of(permisiuni);
        this.isPermisiuniLoading = false;
      },
      error: () => {
        let errorMessage = environment.config.customNotifications.generalMessages.error;
        this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
        this.isPermisiuniLoading = false;
      }
    })
  }

  closeDialog() {
    this.dialogRef?.close({
      success: true
    });
  }

  processToken() {
    const tokenObj = this.authService.returnTokenUser();
    tokenObj.then((token) => {
      this.token = token
      this.permisiuniActiuniService.setToken(token);
    });
  }

  submitForm() {
    this.isLoading = true;

    const updatePermisiuniActiuneData = {
      name: this.form.get('name')?.value,
      slug: this.form.get('slug')?.value,
      id: this.data.id,
      id_permission: this.form.get('id_permission')?.value,
    };

    this.permisiuniActiuniService.updatePermisiuniActiune(updatePermisiuniActiuneData)
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe({
        next: () => {
          this.dialogRef.close({ success: true })
        },
        error: () => {
          let errorMessage = environment.config.customNotifications.generalMessages.error;
          this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
          this.isPermisiuniLoading = false;
        }
      })
  }

  onHttpError(res: any) {
    if (res.errors && res.errors.message && res.errors.message.length > 0) {
      res.errors.message.forEach((msg: string) => {
        this.notificationService.warningSwal(this.errorTitle, msg, this.errorIcon);
      });
    }
    else {
      let errorMessage = environment.config.customNotifications.generalMessages.error;
      this.notificationService.warningSwal(this.errorTitle, errorMessage, this.errorIcon);
    }
  }
}
